import confetti from 'canvas-confetti';

export const triggerCelebration = () => {
  // First burst
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7']
  });

  // Second burst with delay
  setTimeout(() => {
    confetti({
      particleCount: 80,
      spread: 60,
      origin: { y: 0.6 },
      colors: ['#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9']
    });
  }, 250);

  // Third burst for extra celebration
  setTimeout(() => {
    confetti({
      particleCount: 60,
      spread: 50,
      origin: { y: 0.7 },
      colors: ['#FFB6C1', '#87CEEB', '#DEB887', '#F0E68C']
    });
  }, 500);
};

export const triggerSuccessConfetti = () => {
  confetti({
    particleCount: 150,
    spread: 100,
    origin: { y: 0.6 },
    colors: ['#00C851', '#007E33', '#39CCCC', '#001f3f', '#2ECC40']
  });
};